<template>
	<AppCardTable>
		<template #header>
			<AppCardTableHeader
				v-for="header in customerHeaders"
				:key="header.index"
				:header="header"
			/>
		</template>
		<template #body>
			<tr v-for="addedUser in usersInDossier" :key="addedUser.id">
				<AppCardTableCell
					v-for="header in customerHeaders"
					:key="header.index"
					:header="header"
					:value="addedUser[header.model]"
				/>
			</tr>
		</template>
	</AppCardTable>
</template>

<script lang="ts" setup>
import type { User } from "@/generatedApi";
import type { AppCardTableHeaderModel } from "@/models/AppCardTableHeaderModel";
import type { Row } from "@rocicorp/zero";
import { computed } from "vue";

const props = defineProps<{
	users: (Row["dossierUser"] & { appUser?: Row["appUser"] })[];
}>();

const customerHeaders = [
	{
		model: "fullName",
		label: "Naam",
		index: 0,
	},
	{
		model: "emailAddress",
		label: "Email",
		index: 1,
	},
	{
		model: "role",
		label: "Rol",
		index: 2,
	},
] satisfies AppCardTableHeaderModel<User>[];

const usersInDossier = computed<any[]>(() => {
	return props.users
		.filter((u) => u.appUser)
		.map(({ appUser }) => {
			const { role, ...tempUser } = appUser!;

			const formattedRole = role === "intermediary" ? "Intermediair" : "Klant";

			return { ...tempUser, role: formattedRole };
		});
});
</script>

<style lang="scss">
@use "@/style/mixins.scss" as mixins;

.customer-table {
	margin-top: 24px;
	width: 100%;
	border-collapse: collapse;
	transition-duration: 0.2s;

	&.loading {
		filter: blur(3px) brightness(200%);

		.dossier-row {
			cursor: default;
			pointer-events: none;
		}

		.dossier-row:hover {
			background: none;
		}
	}

	td,
	th {
		padding: 10px 4px;
	}

	th {
		text-align: start;
		border-bottom: 2px solid var(--hover-muted);

		.header-content {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
		}

		&.naam {
			width: 100px;
		}

		&.sortable {
			cursor: pointer;

			&:hover {
				.header-content::after {
					color: var(--text-primary);
				}
			}

			&.asc {
				.header-content::after {
					content: "expand_less";
				}
			}

			&.desc {
				.header-content::after {
					content: "expand_more";
				}
			}

			.header-content {
				&::after {
					content: "unfold_more";
					color: var(--text-muted);

					@include mixins.ht-icon;

					font-size: 1.5rem;
				}
			}
		}
	}

	.nothing-found {
		text-align: center;
		color: var(--text-muted);
		user-select: text;
	}
}
</style>
